export default {
  Execution: {
    header: {
      title: 'Ejecución',
      actions: 'Acciones',
    },
    pause_program_modal: {
      pause: 'Pausar',
      resume: 'Reanudar',
      pause_title: 'Pausar el programa',
      resume_title: 'Reanudar el programa',
      reason: 'Motivo',
      select_reason: 'Seleccione un motivo para hacer una pausa',
      drought: 'Sequía',
      hail: 'Granizo',
      lodging: 'Aporcamamiento',
      frost: 'Helada',
      other: 'Otro',
      other_reason: 'Ingrese el motivo',
      resume_explanation_title: 'El programa está en pausa',
      resume_explanation:
        'Al reanudar el programa, el sistema recalculará las fechas de cada solicitud y también puede haber un impacto en la eficiencia de su programa.',
      resume_confirmation: '¿Está seguro de que desea reanudar el programa?',
      describe_reason: 'Describir',
    },
  },
}
